import { useMutation, useQuery } from '@tanstack/react-query';

const KV_REST_API_URL = process.env.NEXT_PUBLIC_KV_REST_API_URL;
const KV_REST_API_TOKEN = process.env.NEXT_PUBLIC_KV_REST_API_TOKEN;

export const useGetKvDataQuery = (key: string, staleTime = Infinity) => {
  const query = useQuery({
    queryKey: ['kv', key],
    queryFn: () => fetchKv(key),
    enabled: !!key,
    retry: false,
    staleTime,
  });

  return { kvData: query.data as { value: string; type: string }, query };
};

export const usePostKvDataMutation = () => {
  const mutation = useMutation({ mutationFn: (params: KvDataType) => postKv(params) });

  return { mutation };
};

type KvDataType = { key: string; value: string | boolean | number; type?: string };

const fetchKv = async (key: string) => {
  const response = await fetch(`${KV_REST_API_URL}/get/${key}`, {
    headers: {
      Authorization: `Bearer ${KV_REST_API_TOKEN}`,
    },
  });
  const data = await response.json();
  return { ...JSON.parse(data.result), param: key };
};

const postKv = async ({ key, value, type }: KvDataType) => {
  const d = await fetch(`${KV_REST_API_URL}/set/${key}`, {
    headers: {
      Authorization: `Bearer ${KV_REST_API_TOKEN}`,
    },
    body: JSON.stringify({
      value,
      type,
    }),
    method: 'POST',
  })
    .then((response) => response.json())
    .then((data) => data);
  return d;
};
